// Release Toggles
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const RELEASE_TOGGLE_ERX = 'erx'
export const RELEASE_TOGGLE_NOW = 'now'

// Experiments
export const NEW_SERP_FR = 'new-serp-layout-fr'
export const SERP_FILTERING = 'serp-filtering-v2'
export const XSELL_NEW_LAYOUT = 'xsell-new-layout'
export const AA_TEST_FR = 'aa-test-fr'
export const PDP_CSW_NEW_ALGO = 'pdp-csw-new-algo'
export const PDP_HIGHER_CSW_NEW_ALGO = 'pdp-higher-csw-new-algo'
export const CUSTOMER_REDIRECT = 'customer-redirect'
export const SERVICE_LINKS_CSW = 'service-links-csw'
